import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    created() {
        const userString = localStorage.getItem('user')
        if (userString) {
            const userData = JSON.parse(userString)
            this.$store.commit('SET_USER_DATA', userData)
        }
        axios.interceptors.request.use(config => {
            console.log('start')
            NProgress.start()
            return config
        })
        axios.interceptors.response.use(
            response => {
                console.log('done')
                NProgress.done()
                NProgress.remove()
                return response
            },
            error => {
                NProgress.done()
                NProgress.remove()
                if (error.response.status === 401) {
                    this.$store.dispatch('logout')
                }
                return Promise.reject(error)
            }
        )
    },
    render: function(h) {
        return h(App)
    }
}).$mount('#app')

var menuToggle = document.getElementById('menu-toggle')
menuToggle.addEventListener('click', function(e) {
    e.preventDefault()
    if (this.classList.contains('open')) {
        document.getElementById('nav').classList.remove('open')
        document.getElementById('masthead').classList.remove('open')
        this.setAttribute('aria-expanded', 'false')
        this.classList.remove('open')
        document.body.classList.remove('nav-open')
    } else {
        document.getElementById('nav').classList.add('open')
        document.getElementById('masthead').classList.add('open')
        this.setAttribute('aria-expanded', 'true')
        this.classList.add('open')
        document.body.classList.add('nav-open')
    }
})

// Refactor to DRY the following & the above
var navLinks = document.querySelectorAll('#nav a')
Array.prototype.forEach.call(navLinks, function(el) {
    el.addEventListener('click', function() {
        document.getElementById('nav').classList.remove('open')
        document.getElementById('masthead').classList.remove('open')
        document
            .getElementById('menu-toggle')
            .setAttribute('aria-expanded', 'false')
        document.getElementById('menu-toggle').classList.remove('open')
        document.body.classList.remove('nav-open')
    })
})
var navButtons = document.querySelectorAll('#nav button')
Array.prototype.forEach.call(navButtons, function(el) {
    el.addEventListener('click', function() {
        document.getElementById('nav').classList.remove('open')
        document.getElementById('masthead').classList.remove('open')
        document
            .getElementById('menu-toggle')
            .setAttribute('aria-expanded', 'false')
        document.getElementById('menu-toggle').classList.remove('open')
        document.body.classList.remove('nav-open')
    })
})
